import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于韩漫屋，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-900 font-heading pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all ${openIdx === idx ? 'bg-primary-500 text-background-50 dark:text-foreground-950 rotate-180' : 'bg-secondary-100 text-secondary-600'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;